import React,{useEffect, useRef} from 'react'
import './header.css'
import Info from './Info'
import HeaderSocial from './HeaderSocial'
import Img from '../../assets/img.png'
import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { motion } from 'framer-motion';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

const Header = () => {
    const NomRef = useRef()
    const { language } = useLanguage();
    const t = translations[language];
  
    const Chargement = () => {
        gsap
          .timeline()
          .fromTo(
            ".lettre",
            {
              x: -100,
              opacity: 0,
            },
            {
              x: 0,
              opacity: 1,
              stagger: 0.33,
              delay: 0.7,
            }
          )
          .to(".lettre", {
            margin: "0 0.3vw",
            delay: 0.8,
            duration: 0.5,
            color: "#3891cc",
          })
          .to(".lettre", {
            margin: "0",
            delay: 0.8,
            duration: 0.5,
            color: "",
          });
    }
    
    useEffect(() => {
        Chargement()
    }, []);

  return (
    <>
      <header id="header">
        <div className="container header__container">
          <motion.h5
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {t.hello}
          </motion.h5>
          
          <motion.h1 
            className="nom" 
            ref={NomRef}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <span className="lettre">T</span>
            <span className="lettre">R</span>
            <span className="lettre">A</span>
            <span className="lettre">O</span>
            <span className="lettre">R</span>
            <span className="lettre">E </span>
            <span className="lettre">L</span>
            <span className="lettre">a</span>
            <span className="lettre">m</span>
            <span className="lettre">i</span>
            <span className="lettre">n</span>
            <span className="lettre">e</span>
          </motion.h1>
          
          <motion.h5 
            className="text-light"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1 }}
          >
            {t.fullstackDeveloper}
          </motion.h5>
          
          <motion.div
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 1.2 }}
          >
            <Info />
          </motion.div>
          
          <motion.div 
            className="img-me"
            initial={{ opacity: 0, scale: 0.5, rotate: -180 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 1.2, delay: 1.5, type: "spring", stiffness: 100 }}
            whileHover={{ 
              scale: 1.1,
              rotate: 5,
              transition: { duration: 0.3 }
            }}
          >
            <img src={Img} alt="monImage" className="img__deux" />
          </motion.div>

          <motion.a 
            href="#contact" 
            className="scoll_down"
            initial={{ opacity: 0, y: 50, rotate: 90 }}
            animate={{ opacity: 1, y: 0, rotate: 90 }}
            transition={{ duration: 0.8, delay: 2 }}
            whileHover={{ 
              y: -10,
              scale: 1.1,
              rotate: 90,
              transition: { duration: 0.2 }
            }}
            whileTap={{ scale: 0.95, rotate: 90 }}
          >
            {t.scrollDown}
          </motion.a>
          
          <motion.div
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            <HeaderSocial />
          </motion.div>
        </div>
      </header>
    </>
  );
}

export default Header